module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee88e1c310700c527a9c.worker.js");
};